import { useQueryClient } from "@tanstack/react-query";

import { View, ViewQueryParams } from "@/types";

export const useAddView = () => {
  const queryClient = useQueryClient();

  return ({
    viewQueryParams,
    newView,
  }: {
    viewQueryParams: ViewQueryParams;
    newView: View;
  }) => {
    queryClient.setQueryData(
      ["views", viewQueryParams],
      (cachedViews: View[]) => {
        return [...cachedViews, newView];
      },
    );
  };
};
